export default __webpack_public_path__ + "static/media/logo_oxeDIN.c66434ff.png";